require('bootstrap');

$('[data-role="collapse"]').click(function(){
  $(this).closest('[data-role="accordion"]').find('[data-role="collapse"]').not(this).removeClass('is-toogle');
  $(this).toggleClass('is-toogle');
  $($(this).data("target")).collapse('toggle');
});
